import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppComponent } from './app.component';
import { SharedModule } from './shared/shared.module'
import { FormsModule } from '@angular/forms'
import { AppRoutingModule } from './app-routing.module'
import { HomeModule } from './home/home.module'
import { CollectionModule } from './collection/collection.module';
import { AdminComponent } from './admin/containers/admin/admin.component'
import { AdminModule } from './admin/admin.module'


@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    BrowserModule,
    FormsModule,

    AppRoutingModule,
    HomeModule,
    CollectionModule,
    SharedModule,
    AdminModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// C:/Users/Thomas/Projekte/palettes/src/app/app.module.ts